import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/routes';

/**
 * 안전한 네비게이션 훅
 *
 * 브라우저 히스토리가 없는 경우(직접 URL 입력, 외부 링크 진입 등)에도
 * 안전하게 뒤로가기를 수행합니다.
 */
export function useSafeNavigate() {
  const navigate = useNavigate();

  /**
   * 안전한 뒤로가기
   * - 히스토리가 있으면 뒤로가기
   * - 히스토리가 없으면 폴백 경로로 이동
   */
  const goBack = useCallback(
    (fallbackPath: string = ROUTES.HOME) => {
      // 히스토리 길이가 2 이상이면 뒤로갈 페이지가 존재
      // (1은 현재 페이지만 있는 경우)
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate(fallbackPath, { replace: true });
      }
    },
    [navigate]
  );

  /**
   * 특정 경로로 이동 (래퍼)
   */
  const goTo = useCallback(
    (path: string, options?: { replace?: boolean }) => {
      navigate(path, options);
    },
    [navigate]
  );

  return {
    navigate,
    goBack,
    goTo,
  };
}
